module.exports = __webpack_public_path__ + "img/ZEN.69fbdf7d.svg";